export default __webpack_public_path__ + "static/media/check_right_icon.88454373.PNG";